import axios from 'axios';
import { TimeZoneDto } from '@/features/devices/device.dto';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';

interface ITimezonesService {
	get(options?: { signal?: AbortSignal }): Promise<ServiceResponse<TimeZoneDto[]>>;
}

class Service implements ITimezonesService {
	async get(options?: { signal?: AbortSignal }): Promise<ServiceResponse<TimeZoneDto[]>> {
		const { data } = await axios.get<ServiceResponse<TimeZoneDto[]>>('/v2/time-zones', {
			signal: options?.signal,
		});
		return data;
	}
}

const TimezoneService: ITimezonesService = new Service();
export default TimezoneService;
